import React, { useState, useEffect } from "react";
// import { Link } from 'react-router-dom'; // Importa Link
import { useHistory, useLocation } from "react-router-dom"; // Importa useHistory
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import Modal from "../../shared/components/UIElements/Modal";
import { useHttpClient } from "../../shared/hooks/http-hook";
import MainCopy from "../components/MainCopy";
import Input from "../../shared/components/FormElements/Input";
import Select from "../../shared/components/FormElements/Select";
import CourseCheckboxes from "../../shared/components/FormElements/CourseCheckboxes"; // Modifica con il percorso corretto

import Button from "../../shared/components/FormElements/Button";
import { VALIDATOR_REQUIRE, VALIDATOR_EMAIL, VALIDATOR_CF, VALIDATOR_FILE, VALIDATOR_CDC, VALIDATOR_MIN_WORKING_DAYS } from "../../shared/util/validators";
import { useForm } from "../../shared/hooks/form-hook";
import { MAX_SELECTABLE_COURSES, MAX_EXTRA_ATTACHMENTS, ALLOWED_FILE_MIME_TYPES, FILE_VALIDATION_ERROR } from "../../shared/constants.js";
import "./MainForm.css";

const MainForm = () => {
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [courses, setCourses] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [isFileReqEnabled, setIsFileReqEnabled] = useState(true);

  const history = useHistory(); // Ottieni la history

  const location = useLocation();

  const inputFields = {
    nome: { label: "Nome", type: "text", validators: [VALIDATOR_REQUIRE()] },
    cognome: { label: "Cognome", type: "text", validators: [VALIDATOR_REQUIRE()] },
    cf: { label: "Codice Fiscale", type: "text", validators: [VALIDATOR_CF()] },
    email: { label: "Email", type: "text", validators: [VALIDATOR_EMAIL()] },
    telefono: { label: "Telefono", type: "text", validators: [VALIDATOR_REQUIRE()] },
    residenzaIndirizzo: { label: "Indirizzo Residenza", type: "text", validators: [VALIDATOR_REQUIRE()] },
    residenzaCitta: { label: "Città Residenza", type: "text", validators: [VALIDATOR_REQUIRE()] },
    residenzaCap: { label: "CAP Residenza", type: "text", validators: [VALIDATOR_REQUIRE()] },
    domicilioIndirizzo: { label: "Indirizzo Domicilio (compilare solo se diverso dalla residenza)", type: "text" },
    domicilioCitta: { label: "Città Domicilio", type: "text" },
    domicilioCap: { label: "CAP Domicilio", type: "text" },
    dataNascita: { label: "Data di nascita", type: "date", validators: [VALIDATOR_REQUIRE()] },
    luogoNascita: { label: "Luogo di nascita", type: "text", validators: [VALIDATOR_REQUIRE()] },
    idBullhorn: { label: "ID Bullhorn", type: "text", validators: [VALIDATOR_REQUIRE()] },
    idCandidatoPowerbase: { label: "ID Candidato Powerbase", type: "text", validators: [VALIDATOR_REQUIRE()] },
  };
  const inputFields2nd = {
    cdcFiliale: { label: "CDC Filiale", type: "text", validators: [VALIDATOR_CDC()], errorText: "Inserire un codice CDC Filiale valido." },
    nomeFiliale: { label: "Nome Filiale", type: "text", validators: [VALIDATOR_REQUIRE()] },
  };
  const inputFields3rd = {
    giorniLavorati: { label: "Dichiaro che i giorni effettivamente lavorati in somministrazione negli ultimi 12 mesi sono", type: "number", validators: [VALIDATOR_MIN_WORKING_DAYS()], errorText: "Inserire un minimo di 45 giorni." },
  };

  const selectFields = {
    titoloStudio: {
      label: "Titolo di studio",
      validators: [VALIDATOR_REQUIRE()],
      enum: ['Nessuno', 'Diploma Scuola Superiore', 'Laurea Magistrale', 'Scuola Media', 'Laurea Triennale', 'Dottorato', 'Licenza Elementare', 'Attestato/Qualifica Professionale'] // Allowed values for titoloStudio
    },
    inseritoDa: {
      label: "Inserito da",
      validators: [VALIDATOR_REQUIRE()],
      enum: ['FORIT', 'Filiale']
    },
    region: {
      label: "Region",
      validators: [VALIDATOR_REQUIRE()],
      enum: ['Adriatica', 'Centro', 'Emilia', 'Lombardia Occ.', 'Lombardia Or.', 'Lombardia Centro', 'Marche e Romagna', 'Nord Ovest', 'Tirrenica', 'Triveneto Occ.', 'Triveneto Or.', 'Vicenza Padova e Rovigo', 'MP Professional', 'Experis']
    },
  };

  const [formState, inputHandler] = useForm(
    {},
    false
  );

  const [dynamicInputs, setDynamicInputs] = useState([]);

  const addInputHandler = () => {
    const newInputId = `fileBustaPaga${dynamicInputs.length + 1}`;
    setDynamicInputs((prevInputs) => [...prevInputs, newInputId]);

    // Initialize the new input in formState
    inputHandler(newInputId, "", false);
  };

  const removeInputHandler = (inputId) => {
    setDynamicInputs((prevInputs) => prevInputs.filter((input) => input !== inputId));
    // Remove the input from formState
    formState.inputs[inputId] = undefined; // Remove the input from formState
  };

  const [isFlipped, setIsFlipped] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const closeEnrollmentsModal = () => {
    setEnrollments([]);
  };

  const handleItemChange = (item) => {
    if (item === null) {
      setSelectedItems([]);
      return;
    }
    if (MAX_SELECTABLE_COURSES === 1) {
      setSelectedItems([item]);
      return;
    }
    setSelectedItems((prevItems) => {
      if (prevItems.includes(item)) {
        return prevItems.filter((i) => i !== item);
      } else {
        return prevItems.length < MAX_SELECTABLE_COURSES ? [...prevItems, item] : prevItems;
      }
    });
  };

  const toggleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const placeSubmitHandler = async (event) => {
    event.preventDefault();

    const transformedInputs = Object.keys(formState.inputs).reduce((acc, key) => {
      if (!key.startsWith("file")) {
        acc[key] = formState.inputs[key].value;
      }
      return acc;
    }, {});

    transformedInputs.dataNascita = `${transformedInputs.dataNascita}T00:00:00Z`;

    try {
      const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL + "/enroll/cfcheck", "POST", JSON.stringify(transformedInputs), {
        "Content-Type": "application/json",
      });

      if (responseData?.activeCourses?.length > 0) {
        setCourses(responseData.activeCourses);
        toggleFlip();
      }

      if (responseData?.enrollments?.length > 0) {
        setEnrollments(responseData.enrollments);
      }

    } catch (err) { }
  };

  const submitSelection = async (event) => {
    event.preventDefault();

    const formData = new FormData();

    const userData = Object.keys(formState.inputs).reduce((acc, key) => {
      if (!key.startsWith("file")) {
        acc[key] = formState.inputs[key].value;
      }
      return acc;
    }, {});

    userData.dataNascita = `${userData.dataNascita}T00:00:00Z`;

    formData.append("userData", JSON.stringify(userData)); // Add JSON data as a string
    // Append selected courses
    formData.append("selectedCourses", JSON.stringify(selectedItems)); // Add selected courses as JSON

    // Append file inputs
    if (formState.inputs.filePattoServizio?.value) {
      formData.append("filePattoServizio", formState.inputs.filePattoServizio.value);
    }
    if (formState.inputs.fileDIDoC2Storico?.value) {
      formData.append("fileDIDoC2Storico", formState.inputs.fileDIDoC2Storico.value);
    }
    if (formState.inputs.fileBustaPaga?.value) {
      formData.append("fileBustaPaga", formState.inputs.fileBustaPaga.value);
    }

    // Append dynamically added file inputs
    dynamicInputs.forEach((inputId) => {
      if (formState.inputs[inputId]?.value) {
        formData.append("fileBustaPaga", formState.inputs[inputId].value);
      }
    });

    try {
      // const responseData = await sendRequest(
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL + "/enroll/submit", // Endpoint del backend per l'invio della candidatura
        "POST",
        formData,
      );
      history.push({
        pathname: "/congratulazioni",
        state: { fromForm: true }, // Passa uno stato per indicare che il redirect è avvenuto dall'invio del form
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const disableFileReqParam = queryParams.get('disableFileReq'); // Replace 'example' with your query param name
    const storedValue = localStorage.getItem("disableFileReq");

    if (storedValue === "true") {
      setIsFileReqEnabled(false);
    } else if (disableFileReqParam && disableFileReqParam === 'true') {
      setIsFileReqEnabled(false);
      localStorage.setItem("disableFileReq", "true");
    }
  }, []);

  useEffect(() => {
    removeInputHandler("fileBustaPaga");
    removeInputHandler("filePattoServizio");
    removeInputHandler("fileDIDoC2Storico");
  }, [isFileReqEnabled]);

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && <LoadingSpinner asOverlay />}

      <div className={`form-container ${isFlipped ? "flipped" : ""}`}>
        <MainCopy className="header-section" />
        {!isFlipped ? (
          <form className="place-form" onSubmit={placeSubmitHandler}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Select
                key="inseritoDa"
                id="inseritoDa"
                label={selectFields.inseritoDa.label}
                validators={selectFields.inseritoDa.validators || []}
                errorText={`Seleziona ${selectFields.inseritoDa.label}`}
                onInput={inputHandler}
                options={[
                  { value: '', label: 'Seleziona un\'opzione' }, // Add empty string option
                  ...selectFields.inseritoDa.enum.map((value) => ({
                    value: value,
                    label: value,
                  })),
                ]}
              />

              {Object.keys(inputFields).map((key) => (
                <Input
                  key={key}
                  id={key}
                  element="input"
                  type={inputFields[key].type}
                  label={inputFields[key].label} // Capitalize the label
                  validators={inputFields[key].validators || []}
                  initialValid={inputFields[key].validators ? false : true}
                  errorText={inputFields[key].errorText || `Inserire ${inputFields[key].label}`}
                  onInput={inputHandler}
                />
              ))}

              <Select
                key="region"
                id="region"
                label={selectFields.region.label}
                validators={selectFields.region.validators || []}
                errorText={`Seleziona ${selectFields.region.label}`}
                onInput={inputHandler}
                options={[
                  { value: '', label: 'Seleziona un\'opzione' }, // Add empty string option
                  ...selectFields.region.enum.map((value) => ({
                    value: value,
                    label: value,
                  })),
                ]}
              />

              {Object.keys(inputFields2nd).map((key) => (
                <Input
                  key={key}
                  id={key}
                  element="input"
                  type={inputFields2nd[key].type}
                  label={inputFields2nd[key].label} // Capitalize the label
                  validators={inputFields2nd[key].validators || []}
                  initialValid={inputFields2nd[key].validators ? false : true}
                  errorText={inputFields2nd[key].errorText || `Inserire ${inputFields2nd[key].label}`}
                  onInput={inputHandler}
                />
              ))}

              <Select
                key="titoloStudio"
                id="titoloStudio"
                label={selectFields.titoloStudio.label}
                validators={selectFields.titoloStudio.validators || []}
                errorText={`Seleziona ${selectFields.titoloStudio.label}`}
                onInput={inputHandler}
                options={[
                  { value: '', label: 'Seleziona un\'opzione' }, // Add empty string option
                  ...selectFields.titoloStudio.enum.map((value) => ({
                    value: value,
                    label: value,
                  })),
                ]}
              />

              {isFileReqEnabled && (
                <>
                  <hr style={{ marginTop: "15px", marginBottom: "15px", borderBottom: 0, borderTop: "1px solid #D3D3D3", width: "100%" }} />
                  <div style={{ textAlign: "center" }}>
                    <p>Clicca su <b>"Scarica modello PDS"</b> per scaricare il documento da compilare e firmare</p>
                    <p>(NUOVO FORMATO PATTO DI SERVIZIO DA USARE DAL 20/05/2026)</p>
                    <Button
                      href={`Diritto Mirato - Patto di servizio.docx`}
                      download="Diritto Mirato - Patto di servizio.docx"
                      size="small"
                      style={{ marginBottom: "3rem", fontSize: "large", alignSelf: "flex-start", marginTop: "1rem", border: "1px solid #56bb6d", backgroundColor: "#56bb6d", color: "#FFF" }}
                    >
                      Scarica modello PDS
                    </Button>
                  </div>
                  <Input
                    id="filePattoServizio"
                    element="input"
                    type="file"
                    label="Patto di servizio compilato, datato e firmato"
                    validators={isFileReqEnabled ? [VALIDATOR_FILE()] : []}
                    errorText={FILE_VALIDATION_ERROR}
                    onInput={inputHandler}
                    accept={ALLOWED_FILE_MIME_TYPES.join(",")}
                  />
                  <Input
                    id="fileDIDoC2Storico"
                    element="input"
                    type="file"
                    label="DID o C2Storico"
                    validators={[VALIDATOR_FILE()]}
                    errorText={FILE_VALIDATION_ERROR}
                    onInput={inputHandler}
                    accept={ALLOWED_FILE_MIME_TYPES.join(",")}
                  />
                  <Input
                    id="fileBustaPaga"
                    element="input"
                    type="file"
                    label="Busta paga"
                    validators={[VALIDATOR_FILE()]}
                    errorText={FILE_VALIDATION_ERROR}
                    onInput={inputHandler}
                    accept={ALLOWED_FILE_MIME_TYPES.join(",")}
                  />
                  {dynamicInputs.map((inputId, index) => (
                    <div key={inputId}>
                      <label htmlFor={inputId} style={{ fontWeight: "bold" }}>{`Busta paga ${index + 2}`}</label>
                      <div className="flex">
                        <Input
                          id={inputId}
                          element="input"
                          type="file"
                          validators={[VALIDATOR_FILE()]}
                          errorText={FILE_VALIDATION_ERROR}
                          className="flex-grow"
                          onInput={inputHandler}
                          accept={ALLOWED_FILE_MIME_TYPES.join(",")}
                        />
                        {index === dynamicInputs.length - 1 && ( // Show the button only for the last input
                          <Button
                            type="button"
                            danger={true}
                            size="small"
                            onClick={() => removeInputHandler(inputId)}
                            style={{ marginLeft: "10px", marginRight: 0 }}>
                            Rimuovi
                          </Button>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
            {isFileReqEnabled && MAX_EXTRA_ATTACHMENTS - dynamicInputs.length > 0 && (
              <Button
                type="button"
                size="small"
                onClick={addInputHandler}
                style={{ paddingTop: "5px", paddingBottom: "5px", margin: 0, backgroundColor: "#005A9C", color: "#FFF", border: "1px solid #005A9C" }}>
                Allega un'altra busta paga
              </Button>
            )}

            <div style={{ display: "flex", flexDirection: "column", marginTop: "15px" }}>
              {Object.keys(inputFields3rd).map((key) => (
                <Input
                  key={key}
                  id={key}
                  element="input"
                  type={inputFields3rd[key].type}
                  label={inputFields3rd[key].label} // Capitalize the label
                  validators={inputFields3rd[key].validators || []}
                  initialValid={inputFields3rd[key].validators ? false : true}
                  errorText={inputFields3rd[key].errorText || `Inserire ${inputFields2nd[key].label}`}
                  onInput={inputHandler}
                />
              ))}
            </div>

            <hr style={{ marginTop: "15px", marginBottom: "15px", borderBottom: 0, borderTop: "1px solid #D3D3D3", width: "100%" }} />

            <Button
              style={{ margin: "0 auto", display: "block", width: "100%" }}
              type="submit"
              disabled={!formState.isValid}>
              Avanti
            </Button>
          </form>
        ) : (
          <form className="place-form" onSubmit={submitSelection}>
            {!!enrollments.length && (
              <Modal
                show={!!enrollments.length}
                onCancel={closeEnrollmentsModal}
                contentClass="place-item__modal-content"
                footerClass="place-item__modal-actions"
                footer={
                  <Button className="button-no-border" onClick={closeEnrollmentsModal}>
                    CHIUDI
                  </Button>
                }
              >
                <div className="modal-body">
                  <h2 className="modal-title">Informazione CF: {enrollments[0].enrolled.cf}</h2>
                  <p className="modal-text">
                    Si informa che il candidato ha già effettuato l'iscrizione ai seguenti corsi:
                  </p>
                  <table className="modal-table">
                    <thead>
                      <tr style={{ textAlign: "left" }}>
                        <th>Corso</th>
                        <th>Filiale</th>
                        <th>in Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      {enrollments.map((enrollment) => (
                        <tr key={enrollment._id}>
                          <td>{enrollment.course?.courseName || "SCEGLIERÒ ENTRO LA FINE DELL'ORIENTAMENTO"}</td>
                          <td>{enrollment.enrolled.cdcFiliale} - {enrollment.enrolled.nomeFiliale}</td>
                          <td>{new Date(enrollment.createdAt).toLocaleDateString("it-IT")}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Modal>
            )}
            <h2 style={{ textAlign: 'center', marginTop: 0, fontSize: '1.2em' }}>
              CORSO INDIVIDUATO INSIEME ALL'EX LAVORATORE (120 ORE - INDENNITA' 3,5 €/H)
            </h2>
            <CourseCheckboxes
              courses={courses} // Passa i corsi al componente CourseCheckboxes
              selectedItems={selectedItems}
              handleItemChange={handleItemChange}
              selectedItemMax={MAX_SELECTABLE_COURSES}
            />

            <hr style={{ marginTop: "15px", marginBottom: "15px", borderBottom: 0, borderTop: "1px solid #D3D3D3", width: "100%" }} />

            <p>
              Premendo il pulsante <span style={{ fontWeight: "bold" }}>"Invia Candidatura"</span>, si avvierà la procedura di caricamento dei
              files precedentemente selezionati e l'invio della candidatura.
            </p>
            <p style={{ fontWeight: "bold" }}>
              Si prega di non chiudere la pagina fino al termine del caricamento, il quale potrebbe richiedere
              qualche minuto a seconda della velocità della connessione e della grandezza dei file allegati.
            </p>

            <hr style={{ marginTop: "15px", marginBottom: "15px", borderBottom: 0, borderTop: "1px solid #D3D3D3", width: "100%" }} />

            <Button
              style={{ margin: "0 auto", display: "block", width: "100%" }}
              type="button" 
              onClick={submitSelection}
              disabled={!selectedItems.length}>
              Invia Candidatura
            </Button>
          </form>
        )}
      </div>
    </React.Fragment>
  );
};

export default MainForm;
